<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/contracts'"
            >Project Contracts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Create
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <project-contract-form
        formType="create"
        contractType="ProjectContract"
        @saveContract="createProjectContract"
      ></project-contract-form>
    </div>
  </div>
</template>
<script>
import ProjectContractForm from "./forms/contractForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
    };
  },
  components: {
    ProjectContractForm,
  },
  methods: {
    formValidation(contract) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!contract.start_date) {
        missingFieldsString += "ProjectContract start date is not selected, ";
        result.isValid = false;
      }
      if (!contract.maturity_date) {
        missingFieldsString +=
          "ProjectContract maturity date is not selected, ";
        result.isValid = false;
      }
      if (!contract.project_id) {
        missingFieldsString += "Project is not selected, ";
        result.isValid = false;
      }
      if (!contract.invested_principal) {
        missingFieldsString += "Principal field is empty, ";
        result.isValid = false;
      }
      let statusList = ["active", "inactive", "notstarted", "closed"];

      if (!statusList.includes(contract.status)) {
        missingFieldsString += "ProjectContract status should be selected, ";
        result.isValid = false;
      }
      let paymentTypes = ["cash", "banktransfer", "cheque", "blockchain"];

      if (!paymentTypes.includes(contract.payment_type)) {
        missingFieldsString += "ProjectContract payment should be selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    createProjectContract(contract) {
      const { isValid, message } = this.formValidation(contract);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("createProjectContract", contract);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      createdProjectContract: (state) =>
        state.contractStore.projectContractCreate.createdProjectContract,
      createProjectContractStatus: (state) =>
        state.contractStore.projectContractCreate.createProjectContractStatus,
      updateProjectContractStatus: (state) =>
        state.contractStore.projectContractUpdate.updateProjectContractStatus,
      deleteProjectContractStatus: (state) =>
        state.contractStore.projectContractDelete.deleteProjectContractStatus,
    }),
  },
  watch: {
    createProjectContractStatus() {
      if (this.createProjectContractStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Contract has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push(
            "/" + this.authUser.userable_type + "/projects/contracts"
          );
        });
      } else if (this.createProjectContractStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Contract creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/createProjectContract.vue